{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mpers_2022-12-31/ssmt-fs-mpers_2022-12-31_role-740000",
  "sheetId": "NotesIssuedCapital",
  "label": "[740000] Notes - Issued Capital",
  "description": "Disclosure of issued capital (MPERS)",
  "controls": [
    {
      "qname": "ssmt-mpers:DisclosureOnIssuedCapitalAbstract",
      "label": "Disclosure on issued capital",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ifrs-smes:DisclosureOfClassesOfShareCapitalExplanatory",
      "label": "Disclosure of issued capital",
      "type": "TextBlock",
      "required": true,
      "ui": {
        "control": "richtext",
        "rows": 8
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfIssuedCapitalHeader",
      "label": "Disclosure of issued capital",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt-mpers:IssuedCapitalHeader",
      "label": "Issued capital",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 3
      }
    },
    {
      "qname": "ssmt-mpers:SharesIssuedAndFullyPaidHeader",
      "label": "Shares issued and fully paid",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 4
      }
    },
    {
      "qname": "ssmt-mpers:NumberOfSharesIssuedAndFullyPaidHeader",
      "label": "Number of shares issued and fully paid",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 5
      }
    },
    {
      "qname": "ifrs-smes:NumberOfSharesIssuedAndFullyPaid",
      "label": "Number of shares issued and fully paid",
      "type": "IntegerItemType",
      "required": true,
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ui": {
        "control": "number",
        "tableColumn": true,
        "useGrouping": true,
        "positiveWholeNumber": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherChangesInNumberOfSharesIssuedAndFullyPaid",
      "label": "Other changes in number of shares issued and fully paid",
      "type": "IntegerItemType",
      "required": true,
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ui": {
        "control": "number",
        "tableColumn": true,
        "useGrouping": true,
        "positiveWholeNumber": true
      }
    },
    {
      "qname": "ssmt-mpers:AmountOfSharesIssuedAndFullyPaidHeader",
      "label": "Amount of shares issued and fully paid",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 5
      }
    },
    {
      "qname": "ssmt-mpers:AmountOfSharesIssuedAndFullyPaidOutstanding:Beginning",
      "label": "Balance at the beginning of period",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:AmountOfSharesIssuedForCashUnderESOS",
      "label": "Amount of shares issued for cash under ESOS",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:AmountOfSharesIssuedForCashUnderPrivatePlacement",
      "label": "Amount of shares issued for cash under private placement",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:AmountOfSharesArisingFromConversionOfICULSBySurrenderOption",
      "label": "Amount of shares arising from conversion of ICULS by surrender option",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:AmountOfSharesArisingFromConversionOfICULSByMandatoryConversion",
      "label": "Amount of shares arising from conversion of ICULS by mandatory conversion",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:AmountOfSharesIssuedAndFullyPaidDuringPeriod",
      "label": "Total amount of shares issued during financial year",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:AmountOfOtherChangesInSharesIssuedAndFullyPaid",
      "label": "Other changes in amount of shares issued and fully paid",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:AmountOfSharesIssuedAndFullyPaidOutstanding:End",
      "label": "Balance at the end of period",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:SharesIssuedButNotFullyPaidHeader",
      "label": "Shares issued but not fully paid",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 4
      }
    },
    {
      "qname": "ssmt-mpers:NumberOfSharesIssuedButNotFullyPaidHeader",
      "label": "Number of shares issued but not fully paid",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 5
      }
    },
    {
      "qname": "ifrs-smes:NumberOfSharesIssuedButNotFullyPaid",
      "label": "Number of shares issued but not fully paid",
      "type": "IntegerItemType",
      "required": true,
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ui": {
        "control": "number",
        "tableColumn": true,
        "useGrouping": true,
        "positiveWholeNumber": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherChangesInNumberOfSharesIssuedAndNotFullyPaid",
      "label": "Other changes in number of shares issued but not fully paid",
      "type": "IntegerItemType",
      "required": true,
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ui": {
        "control": "number",
        "tableColumn": true,
        "useGrouping": true,
        "positiveWholeNumber": true
      }
    },
    {
      "qname": "ssmt-mpers:AmountOfSharesIssuedButNotFullyPaidHeader",
      "label": "Amount of shares issued but not fully paid",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 5
      }
    },
    {
      "qname": "ssmt-mpers:AmountOfSharesIssuedButNotFullyPaidDuringPeriod",
      "label": "Amount of shares issued but not fully paid",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:AmountOfOtherChangesInSharesIssuedButNotFullyPaid",
      "label": "Other changes in amount of shares issued but not fully paid",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:SharesOutstandingHeader",
      "label": "Shares outstanding",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 4
      }
    },
    {
      "qname": "ssmt-mpers:NumberOfSharesOutstandingHeader",
      "label": "Number of shares outstanding",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 5
      }
    },
    {
      "qname": "ifrs-smes:NumberOfSharesOutstanding:Beginning",
      "label": "Number of shares outstanding at beginning of period",
      "type": "IntegerItemType",
      "required": true,
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ui": {
        "control": "number",
        "tableColumn": true,
        "useGrouping": true,
        "positiveWholeNumber": true
      }
    },
    {
      "qname": "ssmt-mpers:NumberOfSharesIssued",
      "label": "Number of outstanding shares issued during financial year",
      "type": "IntegerItemType",
      "required": true,
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ui": {
        "control": "number",
        "tableColumn": true,
        "useGrouping": true,
        "positiveWholeNumber": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherChangesInNumberOfSharesOutstandingDuringPeriod",
      "label": "Other changes in number of shares outstanding",
      "type": "IntegerItemType",
      "required": true,
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ui": {
        "control": "number",
        "tableColumn": true,
        "useGrouping": true,
        "positiveWholeNumber": true
      }
    },
    {
      "qname": "ifrs-smes:NumberOfSharesOutstanding:End",
      "label": "Number of shares outstanding at end of period",
      "type": "IntegerItemType",
      "required": true,
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ui": {
        "control": "number",
        "tableColumn": true,
        "useGrouping": true,
        "positiveWholeNumber": true
      }
    },
    {
      "qname": "ssmt-mpers:AmountOfSharesOutstandingHeader",
      "label": "Amount of shares outstanding",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 5
      }
    },
    {
      "qname": "ssmt-mpers:AmountOfSharesOutstanding:Beginning",
      "label": "Amount of shares outstanding at beginning of period",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:AmountOfOutstandingSharesIssuedDuringPeriod",
      "label": "Amount of outstanding shares issued during period",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherChangesInAmountOfSharesOutstanding",
      "label": "Other changes in amount of shares outstanding",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:AmountOfSharesOutstanding:End",
      "label": "Amount of shares outstanding at end of period",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    }
  ]
}
